<template>
    <b-container class="container-fluid h-100">
        <div class="row h-100">
            <div class="col-sm-9 col-md-7 col-lg-5 mx-auto my-auto">
                <b-overlay :show="isLoading" rounded="sm" >
                    <div class="card card-signin">
                        <div class="card-body">
                            <h5 class="card-title text-center">Sign In</h5>
                                <b-form class="mx-auto my-5" @submit="onLogin" autocomplete="on">
                                    <b-form-group
                                        id="username-group"
                                        label="Username:"
                                        label-for="username"
                                        description="">
                                        <b-form-input
                                            id="username"
                                            type="email"
                                            required
                                            v-model="username"
                                            autocomplete="on"
                                            placeholder="Enter Username"/>
                                    </b-form-group>
                                    <b-form-group
                                        id="password-group"
                                        label="Password:"
                                        label-for="password"
                                        description="">
                                        <b-form-input
                                            id="password"
                                            type="password"
                                            required
                                            v-model="password"
                                            autocomplete="on"
                                            placeholder="Enter Password"/>
                                    </b-form-group>                                    
                                    <b-button 
                                        type="button" 
                                        variant="link" 
                                        v-b-modal.modalForgotPassoword
                                        class="float-left mt-1" >
                                        Forgot Password
                                    </b-button>                             
                                    <b-button 
                                        type="submit" 
                                        variant="primary" 
                                        class="float-right mt-1" >
                                        Login
                                    </b-button>
                                </b-form> 
                        </div>                
                    </div>
                </b-overlay>                  
            </div>
        </div>    
        <b-modal size="sm" hide-footer id="modalForgotPassoword" title="Reset Password">
            <b-form @submit="onSubmitResetPassword">
                <b-form-group id="rp-email-group"
                    label="Email:"
                    label-for="rp-email"
                    description="">
                    <b-form-input
                        id="rp-email"
                        type="email"
                        required
                        v-model="resetPassword.email"
                        autocomplete="on"
                        placeholder="Enter Email"/>
                </b-form-group>
                <div class="text-right mt-2">
                    <b-button size="sm mx-1" variant="danger" @click="$bvModal.hide('modalForgotPassoword')">Cancel</b-button>
                    <b-button size="sm mx-1" type="submit">Ok</b-button>
                </div>
            </b-form>
        </b-modal> 
    </b-container>
</template>
<script>

import { mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
    data(){
        return {
            isLoading:false,
            username:"",
            password:"",

            resetPassword : { email : "" }
        }
    },
    computed: { 
		...mapState({
			store: 'store'
		})
    },
    created() {
        this.getMe()
        // let credential = this.$store.getters.getCredential
        // if(credential !== undefined && credential !== null){
        //     this.username = credential.username
        //     this.password = credential.password
        //     this.onLogin()        
        // }
	},
    methods: {
      async onLogin(event){   
            event.preventDefault()
            let userInfo = {
                username : this.username,
                password : this.password
            }
            let defaultData = this.$store.getters.getDefaultData;
            if(defaultData) {
                let { email, organization, location } = defaultData;
                if(email && userInfo.username && email === userInfo.username){
                    userInfo.organization = organization;
                    userInfo.location = location;                
                }
            }

            this.isLoading = true
            await this.$store.dispatch('apiLogin', userInfo)
            this.isLoading = false
        },
      async getMe() {
            this.isLoading = true
            await this.$store.dispatch('apiMe')
            this.isLoading = false
      },
      onSubmitResetPassword(event) {
          event.preventDefault()
            this.$store.dispatch('apiResetUserPassword', this.resetPassword)
                .then(({status, error}) => {
                    if(status){                   
                        this.$bvModal.hide('modalForgotPassoword')         
                        Swal.fire('Reset!', 'Your Password has been reset.','success')
                    }else{
                        console.error("error",error)
                        Swal.fire('Error',error.msg,'error')
                    }
                })
                .catch(({error, msgError})=>{
                    console.error("apiResetUserPassword-E", error)  
                    Swal.fire('Error',msgError,'error')   
                })  
        }
    }
}
</script>
<style scoped>
.card-signin {
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signin .card-body {
  padding: 1rem;
}

</style>